import React from "react";

const CircleSVG = ({ progress }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="circular-progress" style={{ "--progress": progress ?? 0 }} viewBox="0 0 250 250">
            <circle className="bg" cx="125" cy="125" r="115" fill="none" stroke="#ffda8f" strokeWidth="10"/>
            <circle className="fg" cx="125" cy="125" r="115" fill="none" stroke="#000" strokeWidth="10"/>
        </svg>
    );
};

export default CircleSVG;
